<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Mazot Fiyat Arşivi</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Fiyat</div>
            <!-- <div class="dropdown">
              <button type="button" class="btn btn-white dropdown-toggle ml-3" data-toggle="dropdown">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-lg" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                </svg>
                Filtrele
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <label class="dropdown-item" *ngFor="let f of filterStatus">
                  <input class="form-check-input m-0 mr-2" type="checkbox" [(ngModel)]="f.value"
                    (click)="filter(f.key)">
                  {{getDurumText(f.key)}}
                </label>
              </div>
            </div> -->
          </div>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <!-- <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="talepAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="talepAraText" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="talepAraInputChange()">
                </div>
              </div>
            </div> -->
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCount"
                  (change)="fiyatAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModel" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-lojistik-fiyat-arsiv-liste *ngIf="source" [source]="source.results" (updateFiyatlar)="getLojistikFiyatlar()"></app-lojistik-fiyat-arsiv-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="source">
          <p class="m-0 text-muted"><span>{{source.rowCount}}
              sonuçtan {{source.firstRowOnPage}}</span>-<span>{{source.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === source.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>